import React, { memo } from 'react';
import { Button, TableCell } from '@mui/material';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import LockOpenOutlinedIcon from '@mui/icons-material/LockOpenOutlined';
import { PointOfSale } from '@mui/icons-material';
import { User } from '../types';

interface UserActionsButtonsProps {
  user: User;
  currentUserRole: string | null;
  onOpenActionsDialog: (user: User) => void;
  onToggleActivation: (user: User) => void;
  onTogglePOS: (user: User) => void;
  onToggleReports: (user: User) => void;
  onOpenDeleteDialog: (user: User) => void;
  isActivationButtonDisabled: (user: User) => boolean;
}

const UserActionsButtons: React.FC<UserActionsButtonsProps> = memo(({
  user,
  currentUserRole,
  onOpenActionsDialog,
  onToggleActivation,
  onTogglePOS,
  onToggleReports,
  onOpenDeleteDialog,
  isActivationButtonDisabled
}) => {
  const isViewLike = currentUserRole === 'view' || currentUserRole === 'km' || currentUserRole === 'to';

  return (
    <TableCell sx={{
      width: '490px',
      whiteSpace: 'nowrap',
      padding: '8px',
      height: 36
    }}>
      <Button
        variant="contained"
        color="primary"
        onClick={() => onOpenActionsDialog(user)}
        sx={{ mr: 1 }}
        disabled={isActivationButtonDisabled(user) || isViewLike}
      >
        Действия
      </Button>
      <Button
        variant="contained"
        color={user.deactivation === 0 ? "warning" : "success"}
        onClick={() => onToggleActivation(user)}
        sx={{ mr: 1, width: "80px" }}
        disabled={isActivationButtonDisabled(user) || isViewLike}
      >
        {user.deactivation === 0 ? 'Деакт' : 'Акт'}
      </Button>
      <Button
        variant="contained"
        color={user.pos === 0 ? "error" : "success"}
        onClick={() => onTogglePOS(user)}
        sx={{ mr: 1 }}
        disabled={isActivationButtonDisabled(user) || isViewLike}
      >
        <PointOfSale />
      </Button>
      <Button
        variant="contained"
        color={user.reports === 0 ? "error" : "success"}
        onClick={() => onToggleReports(user)}
        sx={{ mr: 1 }}
        disabled={isActivationButtonDisabled(user) || isViewLike || user.pos === 0}
      >
        <span style={{ marginRight: 5 }}>Отчеты</span>
        {user.reports === 0 ? <LockOutlinedIcon /> : <LockOpenOutlinedIcon />}
      </Button>
      <Button
        variant="contained"
        color="secondary"
        onClick={() => onOpenDeleteDialog(user)}
        disabled={currentUserRole === 'moder' || isViewLike}
      >
        <DeleteForeverIcon />
      </Button>
    </TableCell>
  );
});

UserActionsButtons.displayName = 'UserActionsButtons';

export default UserActionsButtons;

